"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOwnersSearchPage = exports.createGetOwnersSearchPage = exports.fetchOwnersSearchPage = exports.createFetchOwnersSearchPage = exports.getOwnersById = exports.createGetOwnersById = exports.getAllOwners = exports.createGetAllOwners = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _formatOwners = require("reference-resolvers/formatters/formatOwners");

var _formatUsers = _interopRequireDefault(require("reference-resolvers/formatters/formatUsers"));

var _immutable = require("immutable");

var BASE_URL = 'owners/v2/owners';

var formatResponse = function formatResponse(response) {
  return (0, _immutable.Map)({
    owners: (0, _formatOwners.formatOwners)(response),
    users: (0, _formatUsers.default)(response)
  });
};

var createGetAllOwners = function createGetAllOwners(_ref) {
  var httpClient = _ref.httpClient;
  return function () {
    return httpClient.get(BASE_URL, {
      query: {
        contactsOnly: true
      }
    }).then(formatResponse);
  };
};

exports.createGetAllOwners = createGetAllOwners;
var getAllOwners = createGetAllOwners({
  httpClient: _apiClient.default
});
exports.getAllOwners = getAllOwners;

var createGetOwnersById = function createGetOwnersById(_ref2) {
  var httpClient = _ref2.httpClient;
  return function (ids) {
    return httpClient.get(BASE_URL + "/batch", {
      query: {
        ownerId: ids.filter(function (id) {
          return !isNaN(Number(id));
        })
      }
    }).then(function (response) {
      return (0, _formatOwners.formatOwners)((0, _immutable.Map)(response).toList());
    });
  };
};

exports.createGetOwnersById = createGetOwnersById;
var getOwnersById = createGetOwnersById({
  httpClient: _apiClient.default
});
exports.getOwnersById = getOwnersById;

var createFetchOwnersSearchPage = function createFetchOwnersSearchPage(_ref3) {
  var httpClient = _ref3.httpClient;
  return function (props) {
    var _props$toJS = props.toJS(),
        count = _props$toJS.count,
        includeInactive = _props$toJS.includeInactive,
        includeSignature = _props$toJS.includeSignature,
        offset = _props$toJS.offset,
        query = _props$toJS.query;

    return httpClient.get(BASE_URL + "/search", {
      query: {
        includeInactive: includeInactive || false,
        limit: count,
        offset: offset || 0,
        search: query,
        includeSignature: includeSignature || false
      }
    });
  };
};

exports.createFetchOwnersSearchPage = createFetchOwnersSearchPage;
var fetchOwnersSearchPage = createFetchOwnersSearchPage({
  httpClient: _apiClient.default
});
exports.fetchOwnersSearchPage = fetchOwnersSearchPage;

var createGetOwnersSearchPage = function createGetOwnersSearchPage(options) {
  return function (props) {
    var fetchFn = createFetchOwnersSearchPage(options);
    fetchFn(props).then(_formatOwners.formatOwnersPaged);
  };
};

exports.createGetOwnersSearchPage = createGetOwnersSearchPage;

var getOwnersSearchPage = function getOwnersSearchPage(props) {
  return fetchOwnersSearchPage(props).then(_formatOwners.formatOwnersPaged);
};

exports.getOwnersSearchPage = getOwnersSearchPage;